module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-content', [_c('p', [_vm._v("Create Your Starting Layers")]), _vm._v(" "), _c('md-list', _vm._l((_vm.project.layers), function(layer) {
    return _c('layer-lite', {
      key: layer.id,
      attrs: {
        "layer": layer
      },
      on: {
        "deleteLayer": _vm.deleteLayer
      }
    })
  }), 1), _vm._v(" "), _c('layer-new', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addLayer": _vm.addLayer
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794bd6a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/create-project/layers.vue
// module id = 1266
// module chunks = 21